import * as z from 'zod/v4';

export const currencySchema = z
  .string()
  .transform((val) => {
    const parsed = Number.parseInt(val.replace(',', '.'), 10);
    if (Number.isNaN(parsed)) {
      throw new TypeError(`Invalid currency format: "${val}"`);
    }
    return parsed;
  })
  .brand<'Currency'>();
export type Currency = z.infer<typeof currencySchema>;
